import cx from "classnames";
import React from "react";

import { Radio } from "@/mk2/components/forms/Radio";
import useEventCallback from "@/mk2/hooks/useEventCallback";
import { slugify } from "@/mk/common/utils";

import styles from "./RadioWithCount.mscss";

interface OwnProps {
    className?: string;
    name: string;
    label: React.ReactNode;
    value: string;
    checked: boolean;
    count?: number;
    onChange(name: string, value: string);
}

type Props = OwnProps;

export const RadioWithCount: React.FunctionComponent<Props> = ({
    value,
    label,
    checked,
    name,
    onChange,
    className,
    count,
}) => {
    const onChangeCallback = useEventCallback(() => {
        onChange(name, value);
    }, [name, value, onChange]);

    return (
        <Radio
            className={cx(styles.RadioWithCount, className)}
            name={`${name}_${slugify(value)}`}
            label={
                <>
                    <span className={styles.RadioWithCount__label}>{label}</span>
                    <span className={styles.RadioWithCount__count}>{count}</span>
                </>
            }
            value={value}
            checked={checked}
            onChange={onChangeCallback}
        />
    );
};

RadioWithCount.displayName = "RadioWithCount";
